import React, { useState, ChangeEvent, FormEvent, useEffect } from 'react';
import Navbar from '../../Header/Navbar';
import { Button, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, Checkbox, Typography, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import TermsAndConditionsModal from '../../Modals/TermsAndCondition';
import { FormErrors, Member, RegisteredMember } from '../../../Interface/Login.interface';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../App/store';
import { GetCustomerData, RegisterUser } from '../../../Action/auth.Action';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { logout, setCustomerData } from '../../../Slice/Auth.Slice';
import Footer from '../../Footer/Footer';
import { fetchStockItems } from '../../../Action';
import { getStoredAuth } from '../../../StoreData/authUser';

const initialFormData: Member = {
  memberId: 0,
  memberName: '',
  dateofRegn: '',
  mobileNo: '',
  doorNo: '',
  area: '',
  city: '',
  state: '',
  customerType: '',
  customerCategory: '',
  gender: '',
  panNo: '',
  aadharNumber: '',
  dob: '',
  anniversaryDate: '',
  age: 0,
  emailid: '',
  address: '',
  gstin: '',
  registrationType: '',
  country: 'India',
  pinCode: '',
  email: '',
  otp: '',
  totalBills: 0,
  password: '',
  confirmPassword: '',
  newsletter: '',
  agreeTerms: false,
};

export default function RegistrationForm() {
  const [openModal, setOpenModal] = useState(false);
  const [formData, setFormData] = useState<Member>(initialFormData);
  const { isAuthenticated } = useSelector((state: any) => state.auth)
  const [errors, setErrors] = useState<FormErrors>({});
  const numberFields = ['memberId', 'age', 'totalBills'];
  const booleanFields = ['agreeTerms'];
  const { user } = useSelector((state: any) => state.auth);

 
  const dispatch = useDispatch<AppDispatch>()
  const navigate = useNavigate()


  useEffect(() => {
    const stored = getStoredAuth();

    try {
      const data = JSON.parse(stored);
      if (Array.isArray(data) && data.length > 0) {
        navigate('/');
      }
    } catch (err) {
      console.error('Failed to parse stored auth:', err);
    }
  }, []);

  
  useEffect(() => {
    dispatch(GetCustomerData())
  }, [dispatch])

  // Generic change handler for inputs
  const handleChange = (field: keyof Member) => (
    event: ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {

    
    let rawValue = event.target.value;
    let value: string | number | boolean = rawValue;

    if (booleanFields.includes(field)) {
      value = (event.target as HTMLInputElement).checked;
    } else if (numberFields.includes(field)) {
      value = Number(rawValue);
    }

    setFormData(prev => ({
      ...prev,
      [field]: value,
    }));


    validation(field, value)

  };


  const scrollToTop = (): void => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };


  const validation = (field: keyof Member, value: string | number | boolean) => {
    

    switch (field) {
      case 'memberName':
        if (typeof value === 'string') {
          setErrors(prev => ({ ...prev, memberName: value.trim() ? '' : 'Name is required' }));
        }
        break;

      case 'email':
        if (typeof value === 'string' && value !== '') {
          const valid = /\S+@\S+\.\S+/.test(value);
          setErrors(prev => ({ ...prev, email: valid ? '' : 'Invalid email format' }));
        }


        break;

      case 'mobileNo':
        if (field === 'mobileNo' && typeof value === 'string') {


          const mobileExists = user.find((user: any) => user.mobileno === value);

          const valid = /^\d{10}$/.test(value)
          if (!valid) {
            setErrors(prev => ({ ...prev, mobileNo: 'Mobile  Number Should valid ' }));

          }
          else if (value.length !== 10) {
            setErrors(prev => ({ ...prev, mobileNo: 'Mobile number must be 10 digits' }));
          } else if (mobileExists) {
            setErrors(prev => ({ ...prev, mobileNo: 'Mobile number already exists' }));
          } else {
            setErrors(prev => ({ ...prev, mobileNo: '' }));
          }
        }
        break;

      case 'password':
      case 'confirmPassword':
        if (typeof value === 'string') {
          const password = field === 'password' ? value : formData.password;
          const confirmPassword = field === 'confirmPassword' ? value : formData.confirmPassword;

          setErrors(prev => ({
            ...prev,
            confirmPassword:
              password && confirmPassword && password !== confirmPassword
                ? 'Passwords do not match'
                : '',
          }));
        }
        break;

      default:
        break;
    }
  };




  const handleSubmit = async (event: FormEvent) => {

    event.preventDefault();

    const newErrors: FormErrors = {};

    if (!formData.memberName.trim()) {
      newErrors.memberName = 'First Name is required';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Invalid email format';
    }

    if (!formData.mobileNo.trim()) {
      newErrors.mobileNo = 'Mobile Number is required';
    }
    else if (!/^\d{10}$/.test(formData.mobileNo)) {
      newErrors.mobileNo = 'Mobile Number must be 10 digits';
    }

    if (!formData.password) {
      newErrors.password = 'Password is required';
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = 'Confirm Password is required';
    } else if (formData.confirmPassword !== formData.password) {
      newErrors.confirmPassword = 'Passwords do not match';
    }

    setErrors(newErrors);

    // If any errors exist, don't submit
    if (Object.keys(newErrors).length > 0) {
      toast.error('Please fix the errors');
      return;
    }

    // Submit
    const result = await dispatch(RegisterUser(formData));
    if (result.success) {
      toast.success('Successfully Submitted');
      dispatch(logout());
      navigate('/loginSignup');
      scrollToTop()
    } else {
      toast.error('Error in the form');
    }
  };



  const handleOpen = () => setOpenModal(true);
  const handleClose = () => setOpenModal(false);



  const inputStyles = {
    width: '50%',
    padding: '14px 16px',
    border: '2px solid #e0e0e0',
    borderRadius: '8px',
    fontSize: '16px',
    fontFamily: 'inherit',
    transition: 'all 0.3s ease',
    backgroundColor: '#fff',
    outline: 'none',
    marginBottom: '0.5rem',
    marginLeft: '20px'
  };

  const inputFocusStyles = {
    borderColor: '#1976d2',
    boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.1)'
  };

  const labelStyles = {
    display: 'block',
    marginBottom: '8px',
    fontSize: '14px',
    fontWeight: '600',
    color: '#424242',
    letterSpacing: '0.5px',
    marginLeft: '20px'
  };

  const sectionTitleStyles = {
    fontSize: '24px',
    fontWeight: '600',
    color: '#1976d2',
    marginBottom: '24px',
    paddingBottom: '8px',
    borderBottom: '2px solid #1976d2',
    display: 'inline-block',
    marginLeft: '20px',
    marginTop: '5px'
  };

  return (
    <div>
  
      <div>
        <h2 style={sectionTitleStyles}>Create Account</h2>
        <p style={{ marginLeft: '20px' }}>
          If you already have an account with us, please login at the <Link to='/loginSignUp'> login page.</Link>
        </p>

        <form className="p-8" onSubmit={handleSubmit}>
          {/* Personal Details Section */}
          <div className="mb-8">
            <h2 style={sectionTitleStyles}>Personal Details</h2>
            <div className="space-y-4">
              <div>
                <label style={labelStyles}>First Name <span style={{ color: 'red' }}>*</span></label>
                <input
                  type="text"
                  style={inputStyles}
                  value={formData.memberName}
                  onChange={handleChange('memberName')}

                  onFocus={e => Object.assign(e.target.style, inputFocusStyles)}
                  onBlur={e => (e.target.style.borderColor = '#e0e0e0')}
                />
                <p style={{ color: 'red', marginLeft: '20px' }}>{errors.memberName ? errors.memberName : ''}</p>

              </div>

              <div>
                <label style={labelStyles}>Email <span style={{ color: 'red' }}>*</span></label>
                <input
                  type="email"
                  style={inputStyles}
                  value={formData.email}
                  onChange={handleChange('email')}

                  onFocus={e => Object.assign(e.target.style, inputFocusStyles)}
                  onBlur={e => (e.target.style.borderColor = '#e0e0e0')}
                />
                <p style={{ color: 'red', marginLeft: '20px' }}>{errors.email ? errors.email : ''}</p>
              </div>

              <div>
                <label style={labelStyles}>Mobile Number <span style={{ color: 'red' }}>*</span></label>
                <input
                  type="text"
                  style={inputStyles}
                  value={formData.mobileNo}
                  maxLength={10}
                  onChange={handleChange('mobileNo')}
                  onFocus={e => Object.assign(e.target.style, inputFocusStyles)}
                  onBlur={e => (e.target.style.borderColor = '#e0e0e0')}
                />

                <p style={{ color: 'red', marginLeft: '20px' }}>{errors.mobileNo ? errors.mobileNo : ''}</p>

              </div>

              {/* Add other personal fields similarly as needed */}
            </div>
          </div>

          {/* Address Section */}
          <div className="mb-8">
            <h2 style={sectionTitleStyles}>Address</h2>
            <div className="space-y-4">
              <div>
                <label style={labelStyles}>Door No</label>
                <input
                  type="text"
                  style={inputStyles}
                  value={formData.doorNo}
                  onChange={handleChange('doorNo')}
                  onFocus={e => Object.assign(e.target.style, inputFocusStyles)}
                  onBlur={e => (e.target.style.borderColor = '#e0e0e0')}
                />
              </div>

              <div>
                <label style={labelStyles}>Area</label>
                <input
                  type="text"
                  style={inputStyles}
                  value={formData.area}
                  onChange={handleChange('area')}
                  onFocus={e => Object.assign(e.target.style, inputFocusStyles)}
                  onBlur={e => (e.target.style.borderColor = '#e0e0e0')}
                />
              </div>

              <div>
                <label style={labelStyles}>City</label>
                <input
                  type="text"
                  style={inputStyles}
                  value={formData.city}
                  onChange={handleChange('city')}
                  onFocus={e => Object.assign(e.target.style, inputFocusStyles)}
                  onBlur={e => (e.target.style.borderColor = '#e0e0e0')}
                />
              </div>

              <div>
                <label style={labelStyles}>State</label>
                <input
                  type="text"
                  style={inputStyles}
                  value={formData.state}
                  onChange={handleChange('state')}
                  onFocus={e => Object.assign(e.target.style, inputFocusStyles)}
                  onBlur={e => (e.target.style.borderColor = '#e0e0e0')}
                />
              </div>

              <div>
                <label style={labelStyles}>Country</label>
                <select
                  style={inputStyles}
                  value={formData.country}
                  onChange={handleChange('country')}
                  onFocus={e => Object.assign(e.target.style, inputFocusStyles)}
                  onBlur={e => (e.target.style.borderColor = '#e0e0e0')}
                >
                  <option value="India">India</option>
                </select>
              </div>

              <div>
                <label style={labelStyles}>Pin Code</label>
                <input
                  type="text"
                  style={inputStyles}
                  value={formData.pinCode}
                  onChange={handleChange('pinCode')}
                  onFocus={e => Object.assign(e.target.style, inputFocusStyles)}
                  onBlur={e => (e.target.style.borderColor = '#e0e0e0')}
                />
              </div>
            </div>
          </div>

          {/* Login Details Section */}
          <div className="mb-8">
            <h2 style={sectionTitleStyles}>Login Details</h2>
            <div className="space-y-4">
              <div>
                <label style={labelStyles}>Password <span style={{ color: 'red' }}>*</span></label>
                <input
                  type="password"
                  style={inputStyles}
                  value={formData.password}
                  onChange={handleChange('password')}

                  onFocus={e => Object.assign(e.target.style, inputFocusStyles)}
                  onBlur={e => (e.target.style.borderColor = '#e0e0e0')}
                />
              </div>

              <div>
                <label style={labelStyles}>Confirm Password <span style={{ color: 'red' }}>*</span></label>
                <input
                  type="password"
                  style={inputStyles}
                  value={formData.confirmPassword}
                  onChange={handleChange('confirmPassword')}
                  onFocus={e => Object.assign(e.target.style, inputFocusStyles)}
                  onBlur={e => (e.target.style.borderColor = '#e0e0e0')}

                />
                <p style={{ color: 'red', marginLeft: '20px' }}>{errors.confirmPassword ? errors.confirmPassword : ''}</p>

              </div>
            </div>
          </div>

          {/* Newsletter Section */}
          <div className="mb-8">
            <h2 style={sectionTitleStyles}>Newsletter</h2>
            <FormControl component="fieldset" sx={{ mt: 2 }}>
              <FormLabel component="legend" sx={{ fontWeight: 'bold', color: '#333', marginLeft: '20px' }}>
                Subscribe:
              </FormLabel>
              <RadioGroup
                row
                name="newsletter"
                value={formData.newsletter}
                onChange={handleChange('newsletter')}
              >
                <FormControlLabel
                  value="yes"
                  control={<Radio sx={{ color: '#1976d2', marginLeft: '20px' }} />}
                  label="Yes"
                />
                <FormControlLabel
                  value="no"
                  control={<Radio sx={{ color: '#1976d2' }} />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </div>

          {/* Terms & Conditions */}
          <Box sx={{ display: 'flex', alignItems: 'center', ml: 2, mb: 3 }}>
            <Checkbox
              checked={formData.agreeTerms}
              onChange={handleChange('agreeTerms')}
              sx={{ color: '#1976d2' }}
              required
            />
            <Typography sx={{ ml: 1, fontSize: '14px' }}>
              I accept the{' '}
              <Button
                variant="text"
                onClick={handleOpen}
                sx={{ fontSize: '14px', textTransform: 'none', padding: 0, minWidth: 'unset' }}
              >
                Terms & Conditions
              </Button>
            </Typography>
          </Box>

          <Button
            variant="contained"
            color="primary"
            type="submit"
            sx={{ padding: '10px 24px', fontWeight: '600', marginLeft: '20px' }}
            disabled={!formData.agreeTerms}
          >
            Submit
          </Button>
        </form>

        <TermsAndConditionsModal open={openModal} onClose={handleClose} />
      </div>
      <Footer />
    </div>
  );
}
